var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fluid__chart--pie"},[(_vm.render)?_c('apexchart',{attrs:{"type":"pie","options":Object.assign({}, _vm.chartOptions, {labels: _vm.labels}),"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }